/* global axios */
import ApiClient from './ApiClient';

class ThemeSettingsAPI extends ApiClient {
  constructor() {
    super('theme_setting', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(params) {
    return axios.put(this.url, params);
  }
}

export default new ThemeSettingsAPI();
